var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm._v(
        "\n  " +
          _vm._s(_vm.showClosePopUp) +
          _vm._s(_vm.showCloseEditPopUp) +
          _vm._s(_vm.getInvestigationId) +
          "\n  "
      ),
      _vm.show_modal
        ? _c(
            "div",
            { staticStyle: { position: "absolute", "z-index": "200" } },
            [
              _c("transition", { attrs: { name: "modal" } }, [
                _c("div", { staticClass: "modalhold annotation-modal" }, [
                  _c(
                    "div",
                    {
                      staticClass: "modal-mask upl-hold",
                      staticStyle: { "overflow-y": "auto", display: "block" },
                    },
                    [
                      _c("div", { staticClass: "modal-wrapper" }, [
                        _c(
                          "div",
                          {
                            staticClass:
                              "modal-container wider-midB clinicalnote genamet-platform",
                          },
                          [
                            _vm.showloader
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "section-loader prescription-popup",
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../static/images/loader-icon.png"),
                                        id: "loading",
                                      },
                                    }),
                                  ]
                                )
                              : _vm._e(),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "modal-headers pb-0 border-bottom-0 pt-0",
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "ehr-popup-header-colored popup-header-blue",
                                  },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "ehr-popup-title" },
                                      [
                                        _c(
                                          "svg",
                                          {
                                            staticStyle: {
                                              width: "18px",
                                              height: "18px",
                                            },
                                            attrs: {
                                              viewBox: "0 0 24 24",
                                              fill: "none",
                                              stroke: "currentColor",
                                              "stroke-linecap": "round",
                                              "stroke-linejoin": "round",
                                            },
                                          },
                                          [
                                            _c("polygon", {
                                              attrs: {
                                                points:
                                                  "12 2 2 7 12 12 22 7 12 2",
                                              },
                                            }),
                                            _c("polyline", {
                                              attrs: {
                                                points: "2 17 12 22 22 17",
                                              },
                                            }),
                                            _c("polyline", {
                                              attrs: {
                                                points: "2 12 12 17 22 12",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(
                                              _vm.uploadfrom == "genamet"
                                                ? "Insert from Genamet Platform"
                                                : "Upload Picture — This Device"
                                            ) +
                                            "\n                  "
                                        ),
                                      ]
                                    ),
                                    _c(
                                      "button",
                                      {
                                        staticClass: "ehr-popup-close",
                                        attrs: {
                                          type: "button",
                                          "aria-label": "Close",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.closePopUp("goBack")
                                          },
                                        },
                                      },
                                      [_vm._v("×")]
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "col-md-12 model-body-popup" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "layout_2" },
                                  [
                                    _vm._t("body", function () {
                                      return [
                                        _c(
                                          "div",
                                          { staticClass: "upload-outer" },
                                          [
                                            _c(
                                              "div",
                                              {
                                                class:
                                                  _vm.show_add_diatgnosticCenter
                                                    ? "mart-50"
                                                    : " ",
                                              },
                                              [
                                                _vm.hidesection &&
                                                _vm.uploadfrom == "local"
                                                  ? _c(
                                                      "div",
                                                      { staticClass: "mt-3" },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "popup-section-label",
                                                          },
                                                          [
                                                            _vm._v(
                                                              "Step 1 · Select the file"
                                                            ),
                                                          ]
                                                        ),
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "pup-drop",
                                                            class: {
                                                              "is-dragover":
                                                                _vm.dragOver,
                                                            },
                                                            on: {
                                                              click:
                                                                _vm.pupChoose,
                                                              dragover:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  _vm.dragOver = true
                                                                },
                                                              dragleave:
                                                                function (
                                                                  $event
                                                                ) {
                                                                  $event.preventDefault()
                                                                  _vm.dragOver = false
                                                                },
                                                              drop: function (
                                                                $event
                                                              ) {
                                                                $event.preventDefault()
                                                                return _vm.pupDropFile.apply(
                                                                  null,
                                                                  arguments
                                                                )
                                                              },
                                                            },
                                                          },
                                                          [
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "pup-drop-ico",
                                                              },
                                                              [
                                                                _c(
                                                                  "svg",
                                                                  {
                                                                    attrs: {
                                                                      viewBox:
                                                                        "0 0 24 24",
                                                                    },
                                                                  },
                                                                  [
                                                                    _c("rect", {
                                                                      attrs: {
                                                                        x: "3",
                                                                        y: "3",
                                                                        width:
                                                                          "18",
                                                                        height:
                                                                          "18",
                                                                        rx: "2",
                                                                        ry: "2",
                                                                      },
                                                                    }),
                                                                    _c(
                                                                      "circle",
                                                                      {
                                                                        attrs: {
                                                                          cx: "8.5",
                                                                          cy: "8.5",
                                                                          r: "1.5",
                                                                        },
                                                                      }
                                                                    ),
                                                                    _c(
                                                                      "polyline",
                                                                      {
                                                                        attrs: {
                                                                          points:
                                                                            "21 15 16 10 5 21",
                                                                        },
                                                                      }
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "pup-drop-txt",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "pup-drop-title",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        _vm.fileName ||
                                                                          "Choose a picture from this device"
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "pup-drop-hint",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "JPG, PNG or HEIC — or drag the file into this area"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                            _c(
                                                              "button",
                                                              {
                                                                staticClass:
                                                                  "pup-drop-cta",
                                                                attrs: {
                                                                  type: "button",
                                                                },
                                                                on: {
                                                                  click:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      $event.stopPropagation()
                                                                      return _vm.pupChoose.apply(
                                                                        null,
                                                                        arguments
                                                                      )
                                                                    },
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "Upload File"
                                                                ),
                                                              ]
                                                            ),
                                                          ]
                                                        ),
                                                        _c("input", {
                                                          ref: "fileInput",
                                                          staticClass: "d-none",
                                                          attrs: {
                                                            type: "file",
                                                            id: "fileUpload",
                                                            accept: "image/*",
                                                          },
                                                          on: {
                                                            change:
                                                              _vm.onFileChosen,
                                                            error:
                                                              _vm.imageLoadError,
                                                            click:
                                                              _vm.resetValidation,
                                                          },
                                                        }),
                                                        !_vm.validFileExt
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-upload-mail",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Invalid file\n                              type"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        !_vm.validFileSize
                                                          ? _c(
                                                              "span",
                                                              {
                                                                staticClass:
                                                                  "d-block",
                                                              },
                                                              [
                                                                _c(
                                                                  "span",
                                                                  {
                                                                    staticClass:
                                                                      "info-upload-mail",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Selected file\n                              size is invalid"
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.hidesection &&
                                                _vm.uploadfrom == "genamet"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-12",
                                                      },
                                                      [
                                                        _c(
                                                          "ul",
                                                          {
                                                            staticClass:
                                                              "annotation-cat",
                                                          },
                                                          [
                                                            _c("li", [
                                                              _c(
                                                                "a",
                                                                {
                                                                  class: [
                                                                    "categorysel",
                                                                    "selectAll",
                                                                    {
                                                                      active:
                                                                        _vm.selectedimageCategory &&
                                                                        _vm
                                                                          .selectedimageCategory
                                                                          .category ===
                                                                          "All",
                                                                    },
                                                                  ],
                                                                  attrs: {
                                                                    href: "#",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        $event.preventDefault()
                                                                        return _vm.setall.apply(
                                                                          null,
                                                                          arguments
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [_vm._v("All")]
                                                              ),
                                                            ]),
                                                            _vm._l(
                                                              _vm.categorylist,
                                                              function (item) {
                                                                return _c(
                                                                  "li",
                                                                  {
                                                                    key: item.category,
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "a",
                                                                      {
                                                                        class: [
                                                                          "categorysel",
                                                                          "select" +
                                                                            item.category,
                                                                          {
                                                                            active:
                                                                              _vm.selectedimageCategory &&
                                                                              _vm
                                                                                .selectedimageCategory
                                                                                .category ===
                                                                                item.category,
                                                                          },
                                                                        ],
                                                                        attrs: {
                                                                          href: "#",
                                                                        },
                                                                        on: {
                                                                          click:
                                                                            function (
                                                                              $event
                                                                            ) {
                                                                              $event.preventDefault()
                                                                              return _vm.setcategory(
                                                                                item.category
                                                                              )
                                                                            },
                                                                        },
                                                                      },
                                                                      [
                                                                        _vm._v(
                                                                          _vm._s(
                                                                            item.category
                                                                          )
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                )
                                                              }
                                                            ),
                                                          ],
                                                          2
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.hidesection &&
                                                _vm.uploadfrom == "genamet"
                                                  ? _c(
                                                      "div",
                                                      {
                                                        staticClass:
                                                          "col-md-12",
                                                      },
                                                      [
                                                        _c(
                                                          "div",
                                                          {
                                                            staticClass:
                                                              "annotation-gallery",
                                                          },
                                                          [
                                                            _vm.selectedimageCategory !=
                                                            null
                                                              ? _c("h4", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm
                                                                        .selectedimageCategory
                                                                        .category
                                                                    )
                                                                  ),
                                                                ])
                                                              : _vm._e(),
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "row",
                                                              },
                                                              _vm._l(
                                                                _vm.allimages,
                                                                function (
                                                                  item
                                                                ) {
                                                                  return _c(
                                                                    "div",
                                                                    {
                                                                      staticClass:
                                                                        "col-md-4",
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "div",
                                                                        {
                                                                          staticClass:
                                                                            "annotation-image thumbnail",
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "img",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  src: item.url,
                                                                                  alt: item.name,
                                                                                },
                                                                            }
                                                                          ),
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              attrs:
                                                                                {
                                                                                  id: "tick",
                                                                                },
                                                                            },
                                                                            [
                                                                              _c(
                                                                                "input",
                                                                                {
                                                                                  directives:
                                                                                    [
                                                                                      {
                                                                                        name: "model",
                                                                                        rawName:
                                                                                          "v-model",
                                                                                        value:
                                                                                          _vm.imgUrl,
                                                                                        expression:
                                                                                          "imgUrl",
                                                                                      },
                                                                                    ],
                                                                                  attrs:
                                                                                    {
                                                                                      type: "radio",
                                                                                    },
                                                                                  domProps:
                                                                                    {
                                                                                      value:
                                                                                        item.url,
                                                                                      checked:
                                                                                        _vm._q(
                                                                                          _vm.imgUrl,
                                                                                          item.url
                                                                                        ),
                                                                                    },
                                                                                  on: {
                                                                                    change:
                                                                                      function (
                                                                                        $event
                                                                                      ) {
                                                                                        _vm.imgUrl =
                                                                                          item.url
                                                                                      },
                                                                                  },
                                                                                }
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      ),
                                                                    ]
                                                                  )
                                                                }
                                                              ),
                                                              0
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _vm.loader
                                                  ? _c("div", [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "processing_popup upload full-spinner",
                                                          staticStyle: {
                                                            visibility:
                                                              "visible",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "spinner",
                                                            },
                                                            [
                                                              _c("div", {
                                                                staticClass:
                                                                  "bounce1",
                                                              }),
                                                              _c("div", {
                                                                staticClass:
                                                                  "bounce2",
                                                              }),
                                                              _c("div", {
                                                                staticClass:
                                                                  "bounce3",
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ])
                                                  : _vm._e(),
                                                _c("div", [
                                                  _c("div", {
                                                    staticStyle: {
                                                      display: "none",
                                                    },
                                                    attrs: {
                                                      id: "popupContainer",
                                                    },
                                                  }),
                                                  _c(
                                                    "div",
                                                    {
                                                      staticClass:
                                                        "row marker-container",
                                                      staticStyle: {
                                                        display: "none",
                                                        "margin-bottom": "25px",
                                                        "border-bottom":
                                                          "1px solid #808080",
                                                      },
                                                      attrs: { id: "editor" },
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12",
                                                          attrs: {
                                                            id: "sidebarMenu",
                                                          },
                                                        },
                                                        [
                                                          _c("nav", {}, [
                                                            _c(
                                                              "div",
                                                              {
                                                                staticClass:
                                                                  "sidebar-sticky pt-3",
                                                              },
                                                              [
                                                                _c(
                                                                  "ul",
                                                                  {
                                                                    staticClass:
                                                                      "nav flex-column",
                                                                  },
                                                                  [
                                                                    _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "nav-item",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "nav-link active",
                                                                            attrs:
                                                                              {
                                                                                href: "#",
                                                                                id: "btnAnnotate",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.showMarkerArea(
                                                                                    this
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    src: require("@/static/images/annotate-icon.png"),
                                                                                    alt: "",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              "\n                                        Annotate\n                                        "
                                                                            ),
                                                                            _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "sr-only",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  "(current)"
                                                                                ),
                                                                              ]
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                    _c(
                                                                      "li",
                                                                      {
                                                                        staticClass:
                                                                          "nav-item",
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "a",
                                                                          {
                                                                            staticClass:
                                                                              "nav-link",
                                                                            attrs:
                                                                              {
                                                                                href: "#",
                                                                                id: "btnRotate",
                                                                              },
                                                                            on: {
                                                                              click:
                                                                                function (
                                                                                  $event
                                                                                ) {
                                                                                  return _vm.showCropArea(
                                                                                    this
                                                                                  )
                                                                                },
                                                                            },
                                                                          },
                                                                          [
                                                                            _c(
                                                                              "img",
                                                                              {
                                                                                attrs:
                                                                                  {
                                                                                    src: require("@/static/images/rotate-icon.png"),
                                                                                    alt: "",
                                                                                  },
                                                                              }
                                                                            ),
                                                                            _vm._v(
                                                                              "\n                                        Rotate\n                                      "
                                                                            ),
                                                                          ]
                                                                        ),
                                                                      ]
                                                                    ),
                                                                  ]
                                                                ),
                                                              ]
                                                            ),
                                                          ]),
                                                        ]
                                                      ),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "col-md-12",
                                                        },
                                                        [
                                                          _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "holder",
                                                            },
                                                            [
                                                              _c("img", {
                                                                attrs: {
                                                                  id: "imgPreview",
                                                                  src: "#",
                                                                  alt: "pic",
                                                                },
                                                              }),
                                                            ]
                                                          ),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]),
                                              ]
                                            ),
                                          ]
                                        ),
                                      ]
                                    }),
                                  ],
                                  2
                                ),
                                _c("div", { staticClass: "mt-4" }, [
                                  _c(
                                    "div",
                                    { staticClass: "popup-section-label" },
                                    [
                                      _vm._v(
                                        "Step 2 · Clinical context for this picture"
                                      ),
                                    ]
                                  ),
                                  _c("div", { staticClass: "pup-grid" }, [
                                    _c("div", { staticClass: "pup-field" }, [
                                      _c(
                                        "div",
                                        { staticClass: "pup-field-label" },
                                        [
                                          _c(
                                            "svg",
                                            { attrs: { viewBox: "0 0 24 24" } },
                                            [
                                              _c("path", {
                                                attrs: {
                                                  d: "M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z",
                                                },
                                              }),
                                              _c("circle", {
                                                attrs: {
                                                  cx: "12",
                                                  cy: "12",
                                                  r: "3",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "label",
                                            { attrs: { for: "featuresNoted" } },
                                            [_vm._v("Signs / Features Noted")]
                                          ),
                                        ]
                                      ),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.featuresNoted,
                                            expression: "featuresNoted",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "featuresNoted",
                                          rows: "4",
                                          maxlength: "500",
                                          placeholder:
                                            "What is visible in the image — e.g. patchy opacity in right lower zone, blunted costophrenic angle, no pneumothorax...",
                                        },
                                        domProps: { value: _vm.featuresNoted },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.featuresNoted =
                                              $event.target.value
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "pup-chiprow" },
                                        _vm._l(_vm.signChips, function (c) {
                                          return _c(
                                            "button",
                                            {
                                              key: c.text,
                                              staticClass: "pup-chip",
                                              attrs: { type: "button" },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.addChip(
                                                    "featuresNoted",
                                                    c.text
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v(_vm._s(c.label))]
                                          )
                                        }),
                                        0
                                      ),
                                    ]),
                                    _c("div", { staticClass: "pup-field" }, [
                                      _c(
                                        "div",
                                        { staticClass: "pup-field-label" },
                                        [
                                          _c(
                                            "svg",
                                            { attrs: { viewBox: "0 0 24 24" } },
                                            [
                                              _c("path", {
                                                attrs: { d: "M9 18h6" },
                                              }),
                                              _c("path", {
                                                attrs: { d: "M10 22h4" },
                                              }),
                                              _c("path", {
                                                attrs: {
                                                  d: "M12 2a7 7 0 0 0-4 12.7V17h8v-2.3A7 7 0 0 0 12 2z",
                                                },
                                              }),
                                            ]
                                          ),
                                          _c(
                                            "label",
                                            { attrs: { for: "inference" } },
                                            [_vm._v("Inference")]
                                          ),
                                        ]
                                      ),
                                      _c("textarea", {
                                        directives: [
                                          {
                                            name: "model",
                                            rawName: "v-model",
                                            value: _vm.inference,
                                            expression: "inference",
                                          },
                                        ],
                                        staticClass: "form-control",
                                        attrs: {
                                          id: "inference",
                                          rows: "4",
                                          maxlength: "500",
                                          placeholder:
                                            "What it means clinically — e.g. suggestive of right basal consolidation, correlate with CBC and clinical findings...",
                                        },
                                        domProps: { value: _vm.inference },
                                        on: {
                                          input: function ($event) {
                                            if ($event.target.composing) {
                                              return
                                            }
                                            _vm.inference = $event.target.value
                                          },
                                        },
                                      }),
                                      _c(
                                        "div",
                                        { staticClass: "pup-chiprow" },
                                        _vm._l(
                                          _vm.inferenceChips,
                                          function (c) {
                                            return _c(
                                              "button",
                                              {
                                                key: c.text,
                                                staticClass: "pup-chip",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.addChip(
                                                      "inference",
                                                      c.text
                                                    )
                                                  },
                                                },
                                              },
                                              [_vm._v(_vm._s(c.label))]
                                            )
                                          }
                                        ),
                                        0
                                      ),
                                    ]),
                                  ]),
                                ]),
                              ]
                            ),
                            _c(
                              "div",
                              { staticClass: "modal-bottom pup-foot" },
                              [
                                _c("div", { staticClass: "pup-foot-note" }, [
                                  _c(
                                    "svg",
                                    { attrs: { viewBox: "0 0 24 24" } },
                                    [
                                      _c("circle", {
                                        attrs: { cx: "12", cy: "12", r: "10" },
                                      }),
                                      _c("line", {
                                        attrs: {
                                          x1: "12",
                                          y1: "16",
                                          x2: "12",
                                          y2: "12",
                                        },
                                      }),
                                      _c("line", {
                                        attrs: {
                                          x1: "12",
                                          y1: "8",
                                          x2: "12.01",
                                          y2: "8",
                                        },
                                      }),
                                    ]
                                  ),
                                  _vm._v(
                                    "\n                  Context is stored with the picture and carried into the consultation note\n                "
                                  ),
                                ]),
                                _c(
                                  "button",
                                  {
                                    staticClass: "btn av-btn-ghost",
                                    attrs: { type: "button" },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.closePopUp("goBack")
                                      },
                                    },
                                  },
                                  [_vm._v("Cancel")]
                                ),
                                _vm.uploadfrom == "genamet" && _vm.showbtninsert
                                  ? _c(
                                      "button",
                                      {
                                        staticClass: "btn av-btn-primary",
                                        on: {
                                          click: function ($event) {
                                            return _vm.insertImage()
                                          },
                                        },
                                      },
                                      [_vm._v("Insert")]
                                    )
                                  : _c(
                                      "button",
                                      {
                                        staticClass: "av-btn-primary",
                                        attrs: {
                                          id: "btnSubmit",
                                          disabled: !_vm.hasFile,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.onsubmitann()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "svg",
                                          { attrs: { viewBox: "0 0 24 24" } },
                                          [
                                            _c("line", {
                                              attrs: {
                                                x1: "12",
                                                y1: "5",
                                                x2: "12",
                                                y2: "19",
                                              },
                                            }),
                                            _c("line", {
                                              attrs: {
                                                x1: "5",
                                                y1: "12",
                                                x2: "19",
                                                y2: "12",
                                              },
                                            }),
                                          ]
                                        ),
                                        _vm._v(
                                          "\n                  Attach to Consultation\n                "
                                        ),
                                      ]
                                    ),
                              ]
                            ),
                          ]
                        ),
                      ]),
                    ]
                  ),
                ]),
              ]),
            ],
            1
          )
        : _vm._e(),
      _c(
        "transition",
        { attrs: { name: "fade" } },
        [
          _vm.isdisplaymsg
            ? _c("Messages", {
                attrs: {
                  iserror: _vm.iserrormsg,
                  datamessage: _vm.sucessmsgtext,
                  isVisible: _vm.isdisplaymsg,
                },
                on: { closemsg: _vm.closeMessage },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }